import {RouterModule, Routes} from "@angular/router";
import {isDevMode, NgModule} from "@angular/core";

import {AuthenticationRoutesNames} from "@shared/constans/authentication-routes-names.constans";

import {WelcomeComponent} from "@authentication/routes/welcome/welcome.component";
import {LoginComponent} from "@authentication/routes/login/login.component";

import {SelectDatabaseComponent} from "@authentication/routes/select-database/select-database.component";
import {CreateAccountComponent} from "@authentication/routes/create-account/create-account.component";
import {
  CreateAccountConfirmationComponent
} from "@authentication/routes/create-account-confirmation/create-account-confirmation.component";
import {ResetPasswordComponent} from "@authentication/routes/reset-password/reset-password.component";
import {
  ResetPasswordConfirmationComponent
} from "@authentication/routes/reset-password-confirmation/reset-password-confirmation.component";
import {SetNewPasswordComponent} from "@authentication/routes/set-new-password/set-new-password.component";
import {
  SetNewPasswordConfirmationComponent
} from "@authentication/routes/set-new-password-confirmation/set-new-password-confirmation.component";

import {WelcomeGuard} from "@authentication/guards/welcome.guard";
import {LogoutComponent} from "@authentication/routes/logout/logout.component";
import {LinkLoginComponent} from "@authentication/routes/link-login/link-login.component";
import {SelectDatabaseGuard} from "@authentication/guards/select-database.guard";
import {HandoverLoginComponent} from "@authentication/routes/handover-login/handover-login.component";

const authenticationRoutes: Routes = [
  {path: '', redirectTo: 'welcome'},
  {
    path: AuthenticationRoutesNames.share + '/:token',
    component: LinkLoginComponent
  },
  {
    path: AuthenticationRoutesNames.handover + '/:token',
    component: HandoverLoginComponent
  },
  {
    path: AuthenticationRoutesNames.welcome,
    component: WelcomeComponent,
    canActivate: [WelcomeGuard]
  },
  {
    path: AuthenticationRoutesNames.login,
    component: LoginComponent,
  },
  {
    path: AuthenticationRoutesNames.selectDatabase,
    component: SelectDatabaseComponent,
    canActivate: [SelectDatabaseGuard]
  },
  {path: AuthenticationRoutesNames.createAccount, component: CreateAccountComponent},
  {
    path: AuthenticationRoutesNames.createAccountConfirmation,
    component: CreateAccountConfirmationComponent
  },
  {path: AuthenticationRoutesNames.resetPassword, component: ResetPasswordComponent},
  {
    path: AuthenticationRoutesNames.resetPasswordConfirmation + '/:email',
    component: ResetPasswordConfirmationComponent
  },
  {path: AuthenticationRoutesNames.setNewPassword, component: SetNewPasswordComponent},
  {path: AuthenticationRoutesNames.setNewPasswordConfirmation, component: SetNewPasswordConfirmationComponent},
  {path: AuthenticationRoutesNames.logout, component: LogoutComponent}
];

@NgModule({
  imports: [RouterModule.forChild(authenticationRoutes)],
  exports: [RouterModule],
})
export class AuthenticationRoutesModule {
  constructor() {
    if (isDevMode())
      console.log('AuthenticationRoutesModule');
  }
}
